<app-esri-ticket
  [refSubject]=refSubject
  [pointsToShow]="pointsToShow"
  [filteredPoints]="filteredPoints"
  [project]="project"
></app-esri-ticket>
